import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { StripeService } from 'ngx-stripe';
import { NotificationService } from '../../shared/notification.service';
import { AccountService } from '../../shared/services/account.service';
import { PaymentService } from '../../shared/services/payment.service';
import { ActiveCard, PaymentParams, SubscriptionParams, User } from '../account.model';

@Component({
  selector: 'cc-subscription-payment',
  templateUrl: './subscription-payment.component.html',
  styleUrls: ['./subscription-payment.component.scss']
})
export class SubscriptionPaymentComponent implements OnInit, OnDestroy {
  public user: User;
  public paymentStatusParams: PaymentParams;
  public piid: string;
  public subscriptionParams: SubscriptionParams;
  public spinner: boolean;
  public activeCard: ActiveCard;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private stripeService: StripeService,
    private notificationService: NotificationService,
    private accountService: AccountService,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.activeCard = {
      brand: '',
      cardExpired: false,
      expMonth: null,
      expYear: null,
      last4Digits: ''
    };
    this.piid = this.route.snapshot.queryParams['piid'];
    this.accountService.getCard().subscribe((response: ActiveCard) => {
      this.activeCard = response;
    });

    this.accountService.getUser().subscribe((user: User) => {
      console.log(user);
      this.user = user;
    });

    this.accountService.getSubscriptionParams().subscribe((subscription: SubscriptionParams) => {
      this.subscriptionParams = subscription;
    });

    this.accountService.getPaymentStatus(this.piid).subscribe((response: PaymentParams) => {
      this.paymentStatusParams = response;
    });

    this.paymentService.spinnerActivate.subscribe(activator => {
      this.spinner = activator;
    });
  }

  onConfirm(event) {
    if (event) {
      this.pay();
    }
  }

  pay() {
    this.paymentService.checkPaymentStatus(() => this.accountService.getPaymentStatus(this.piid), '/account');
  }

  ngOnDestroy() {
    this.notificationService.dismiss();
  }
}
